














import inputMixin from 'library/mixins/input-mixin'

export default
	name: "formRadioList"

	mixins: [ inputMixin ]

	props:
		options:
			type: Array
			default: -> []

		value: String | Number

		type:
			type: String
			default: "standard"




